import React from 'react'
import Skeleton from '../UI/Skeleton'
class SidebarEmulation extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Skeleton className="bar-title lg-font-size" count={2} />
                <Skeleton className="bar-progress lg-font-size" style={{ paddingTop: 0, marginTop: '40px' }} width={'50%'} />
                <Skeleton className="custom-progress" />
                <div className="lesson-items pt-0">
                    <div className="lesson-dropdown">
                        <div className="lesson-dropdown-title">
                            <Skeleton className="text md-font-size" width={250} />
                            <Skeleton className="active dropdown-icon" width={16} height={16} circle={true} />
                        </div>
                        <hr className="m-0" />
                        <div className="lesson-dropdown-title">
                            <Skeleton className="text md-font-size" width={250} />
                            <Skeleton className="active dropdown-icon" width={16} height={16} circle={true} />
                        </div>
                        <hr className="m-0" />
                        <div className="lesson-dropdown-title">
                            <Skeleton className="text md-font-size" width={250} />
                            <Skeleton className="active dropdown-icon" width={16} height={16} circle={true} />
                        </div>
                        <hr className="m-0" />
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default SidebarEmulation



// WEBPACK FOOTER //
// ./src/components/Study/SidebarEmulation.jsx